import { useState, useEffect } from 'react';

// Utils
import { getLayoutElement, isSidebarOpen } from '@/utils/chatbot';

/**
 * Hook to detect chatbot sidebar visibility by monitoring layout-workspace classes
 */
export const useChatbotSidebarVisibility = (): boolean => {
  const [isChatbotSidebarOpen, setIsChatbotSidebarOpen] =
    useState(isSidebarOpen);

  useEffect(() => {
    const checkSidebarState = () => setIsChatbotSidebarOpen(isSidebarOpen());

    const observer = new MutationObserver(checkSidebarState);
    const layoutElement = getLayoutElement();

    if (layoutElement) {
      observer.observe(layoutElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    return () => observer.disconnect();
  }, []);

  return isChatbotSidebarOpen;
};
